
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GLOBAL } from './global.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Customer } from '../models/customer';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
    public url;
    public service: string = 'customerService';

    constructor(private _http: HttpClient) {
        this.url = GLOBAL.url;
    }

    getCustomers(page, customer: Customer) {
        let params: HttpParams = new HttpParams();

        if (customer.name) {
            params = params.set('name', customer.name);
        }

        if (Number(customer.dni) > 0) {
            params = params.set('dni', customer.dni.toString())
        }
         
        if (customer.checkingAccountEnabled){
            params = params.set('checkingaccount','true');
        }else{
            params = params.set('checkingaccount','false');
        }

        if (customer.enabled){
            params = params.set('onlyenabled','true');
        }else{
            params = params.set('onlyenabled','false');
        }                
        return this._http.get(this.url + this.service + '/listSearch/' + page,
            { responseType: 'text', observe: 'response', headers: new HttpHeaders(), params: params }).pipe(map(res => { 
              return res }));
    }

    getCustomer(token, dni) {

        return this._http.get(this.url + this.service + '/' + dni,
            { responseType: 'text', observe: 'response', headers: new HttpHeaders() }).pipe(map(res => { 
              return res }));
    }

    getCustomerById(id) {
    return this._http.get(this.url + this.service + '/getCustomer/' + id, {
        responseType: 'text',
        observe: 'response'
    }).pipe(map(res => res));
    }

    saveCustomer(token, customer) {
        let body = JSON.stringify(customer);
        return this._http.post(this.url + this.service, body, { observe: 'response', headers: new HttpHeaders() }
        ).pipe(map(
            res => res
        ));
    }

    updateCustomer(token, customer) {
        let body = JSON.stringify(customer);
        return this._http.put(this.url + this.service, body, { observe: 'response', headers: new HttpHeaders() }
        ).pipe(map(
            res => res
        ));
    }

    deleteCustomer(token, id) {
        return this._http.delete(this.url + this.service + '/' + id, { observe: 'response', headers: new HttpHeaders() }
        ).pipe(map(
            res => res
        ));
    }

    hashclu(token, arrayPos, val: string, date: string) {
        let params: HttpParams = new HttpParams();

        if (val == "1") {
            params = params.set('dateFrom', date);
        }

        let body = JSON.stringify(arrayPos);
        return this._http.post(this.url + this.service + '/hashclu', body, { observe: 'response', headers: new HttpHeaders(), params: params }
        ).pipe(map(
            res => res
        ));
    }

    dateToExport(token) {
      return this._http.get(this.url + this.service + '/dateToExport',
        { responseType: 'text', observe: 'response', headers: new HttpHeaders() }).pipe(map(res => { 
          return res }));
    }

    // TODO: reactivar lógica mayorista/minorista cuando sea necesario
    // isWholesaler(id: number): Observable<boolean> {
    //     return this.getCustomerById(id).pipe(
    //         map((res: any) => {
    //         const body = JSON.parse(res.body);
    //         return body.customerType && body.customerType.toLowerCase() === 'mayorista';
    //         })
    //     );
    // }
    isWholesaler(_id: number): Observable<boolean> {
        return of(true);
    }

}